import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { TrendingUp, ChevronRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Compact global crowdfunding progress bar for the footer — links to /investet.
export default function InvestmentProgressBar() {
  const { language } = useLanguage();
  const [p, setP] = useState(null);
  const tr = (lv, en, ru) => (language === 'lv' ? lv : language === 'ru' ? ru : en);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/investments/progress`)
      .then(({ data }) => { if (!cancelled) setP(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!p) return null;
  const eur = (n) => new Intl.NumberFormat('lv-LV').format(Math.round(n || 0));

  return (
    <Link
      to="/investet"
      className="block mb-6 pb-6 border-b border-[#F0EFEB] group"
      data-testid="investment-progress-bar"
    >
      <div className="flex items-center justify-between mb-2 flex-wrap gap-x-3 gap-y-1">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-[#121212] group-hover:text-[#D97736] transition-colors">
          <TrendingUp className="w-4 h-4 text-[#D97736]" />
          {tr('KoLV investīciju mērķis', 'KoLV investment goal', 'Инвестиционная цель KoLV')}
          <ChevronRight className="w-4 h-4 text-[#D97736] opacity-0 group-hover:opacity-100 transition-opacity" />
        </span>
        <span className="text-sm text-[#5C5C5C]">
          <strong className="text-[#4A6B53]">€{eur(p.collected)}</strong> / €{eur(p.goal)}
          <span className="mx-1.5 text-[#E5E4E0]">·</span>
          <strong className="text-[#121212]">{p.backers_count}</strong> {tr('investori', 'investors', 'инвесторов')}
        </span>
      </div>
      <div className="h-2 rounded-full bg-[#F0EFEB] overflow-hidden" role="progressbar" aria-valuenow={p.percent} aria-valuemin={0} aria-valuemax={100}>
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#D97736] to-[#E8A05C] transition-all duration-700"
          style={{ width: `${p.percent}%` }}
          data-testid="progress-fill"
        />
      </div>
      <p className="mt-2 text-xs text-[#8A8A8A]">
        {tr(
          <>Kļūsti par investoru — <strong className="text-[#D97736]">{p.profit_share_pct}% no KoLV peļņas</strong> tiek sadalīti proporcionāli. <span className="text-[#D97736] font-medium">Investēt →</span></>,
          <>Become an investor — <strong className="text-[#D97736]">{p.profit_share_pct}% of KoLV profit</strong> shared proportionally. <span className="text-[#D97736] font-medium">Invest →</span></>,
          <>Стань инвестором — <strong className="text-[#D97736]">{p.profit_share_pct}% прибыли KoLV</strong> распределяется пропорционально. <span className="text-[#D97736] font-medium">Инвестировать →</span></>
        )}
      </p>
    </Link>
  );
}

